'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

interface AppImageProps {
  src?: string | null;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
  quality?: number;
  placeholder?: 'blur' | 'empty';
  blurDataURL?: string;
  fill?: boolean;
  sizes?: string;
  onClick?: () => void;
  fallbackSrc?: string;
  [key: string]: unknown;
}

function AppImage({
  src,
  alt,
  width,
  height,
  className = '',
  priority = false,
  quality = 75,
  placeholder = 'empty',
  blurDataURL,
  fill = false,
  sizes,
  onClick,
  fallbackSrc = '/assets/images/no_image.png',
  ...props
}: AppImageProps) {
  const [imageSrc, setImageSrc] = useState(src || fallbackSrc);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setImageSrc(src || fallbackSrc);
    setIsLoading(true);
  }, [src, fallbackSrc]);

  const handleError = () => {
    if (imageSrc !== fallbackSrc) setImageSrc(fallbackSrc);
    setIsLoading(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  const mergedClassName = `${className} ${isLoading ? 'bg-gray-200' : ''} ${
    onClick ? 'cursor-pointer hover:opacity-90 transition-opacity' : ''
  }`.trim();

  const sharedProps = {
    src: imageSrc,
    alt,
    className: mergedClassName,
    priority,
    quality,
    placeholder,
    blurDataURL,
    unoptimized: true,
    onError: handleError,
    onLoad: handleLoad,
    onClick,
    ...props,
  };

  if (fill) {
    return <Image data-component-id="src/components/ui/AppImage.tsx:76:11" data-component-path="src/components/ui/AppImage.tsx" data-component-line="76" data-component-end-line="76" data-component-file="AppImage.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...sharedProps} fill sizes={sizes || '100vw'} />;
  }

  return <Image data-component-id="src/components/ui/AppImage.tsx:79:9" data-component-path="src/components/ui/AppImage.tsx" data-component-line="79" data-component-end-line="79" data-component-file="AppImage.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...sharedProps} width={width || 400} height={height || 300} />;
}

export default AppImage;
